import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject, Subscription, filter, switchMap, tap, takeUntil, catchError, EMPTY, Observable } from "rxjs";
import { EntityType } from "src/app/enums/entity-type.enum";
import { ApiService } from "src/app/services/api.service";
import { RoutingService } from "src/app/services/routing.service";

import { ArchiveMapInformationDto, ScientificArchiveDocumentDto } from "src/app/models/scientific-archive-document-dto";
import { LABELS } from "./scientific-archive-document.constant";
import { ImageDto } from "src/app/models/image-dto";
import { MessageService } from "primeng/api";
import { HttpResponse } from '@angular/common/http';
import { eDetailsView } from "../shared/components/tablet-view-tabs/details-veiw.enum";
import { LanguageService } from "src/app/services/language.service";
import { GaService } from "src/app/services/ga.service";

@Component({
    selector: 'app-scientific-archive-document',
    templateUrl: './scientific-archive-document.component.html',
    styleUrls: ['./scientific-archive-document.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MessageService]
})
export class ScientificArchiveDocumentComponent implements OnInit, OnDestroy {

    @Input() closeClicked!: Subject<void>;
    @Input() currentLanguage!: Observable<string>;
    LABELS = LABELS;
    entityId: number = -1;
    archiveDocument: ScientificArchiveDocumentDto | undefined;
    archiveImages: ImageDto[] | undefined;
    archiveThumbnails: ImageDto[] | undefined;
    shapes: any[] = [];
    zoomShapeIds: string[] = [];

    detailsView: eDetailsView = eDetailsView.Info;
    eDetailsView = eDetailsView;
    hasError = false;
    errorMessage = '';

    private entityDetailsSubscription?: Subscription;

    constructor(
        private api: ApiService,
        private routingService: RoutingService,
        private messageService: MessageService,
        private cd: ChangeDetectorRef,
        private languageService: LanguageService,
        private gaService:GaService
    ) {
    }

    ngOnInit(): void {
        this.archiveDocument = undefined;
        this.archiveImages = undefined;
        this.hasError = false;
        this.entityDetailsSubscription = this.routingService.entityDetails$.pipe(
            filter((entityDetails) => {
                return !!entityDetails.id && [EntityType.SCIENTIFIC_ARCHIVE_DOCUMENTS].includes(entityDetails.type as EntityType);
            }),
            tap((entityDetails) => {
                const { id } = entityDetails;
                this.entityId = id;
            }),
            switchMap((entityDetails) => {
                return this.api.getArchive(entityDetails.id).pipe(
                    takeUntil(this.closeClicked),
                    catchError((error) => {
                        this.hasError = true;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error.message || 'General error'
                        });
                        return EMPTY;
                    }));
            })
        )
            .subscribe((data) => {
                if (data == null) return;
                this.archiveDocument = data;
                if (data.images !== undefined && data.images.length > 0) {
                    this.archiveImages = data.images.map((item) => {
                        return {
                            archivesImageId: '',
                            imageId: item.imageId + '',
                            imageUrl: item.imageUrl,
                            imageAngle: '',
                            imageDescription: '',
                            photographerName: ''
                        };
                    })
                    this.archiveThumbnails = data.images.map(img => ({
                        ...img,
                        imageId: img.imageId.toString(),
                        imageUrl: img.imageUrl.includes('?') 
                          ? img.imageUrl + '&type=thumbnail'
                          : img.imageUrl + '?type=thumbnail'
                      }));

                }
                if (data.archiveMapInformation !== undefined && data.archiveMapInformation.length > 0) {
                    this.shapes = data.archiveMapInformation.map((i) => this.convertToConvertedShape(i));
                    this.zoomShapeIds = data.archiveMapInformation.map(i => `${i.shapeId}`);
                }

                this.cd.markForCheck();
            });

    }

    OnViewFolder(entityId: number) {
        this.gaService.trackWithGA(EntityType.SCIENTIFIC_ARCHIVE_FOLDERS, 'entityType')
        const queryParams = {
            "entityId": entityId,
            "entityType": EntityType.SCIENTIFIC_ARCHIVE_FOLDERS
        }
        this.routingService.navigateWithMerge(queryParams, ['']);
    }



    private convertToConvertedShape(shape: ArchiveMapInformationDto): any {
        const entity = shape.shapeData.entity;
        return {
            shapeId: shape.shapeId.toString(),
            wkt: shape.shapeWkt,
            layerName: "שכבת תוצאות שאילתה",
            hidden: false,
            isExtent: true,
            shapeData: {
                entity: {
                    entityId: entity.entityId,
                    entityType: entity.entityType
                },
            },
            styledParams: {
                geometryType: "Polygon", // Assuming default geometry type is Polygon
                fillColor: [255, 165, 0, 0.2],
                borderColor: [255, 165, 0],
                borderWidth: 2,
            },
        };
    }

    ngOnDestroy(): void {
        this.entityDetailsSubscription?.unsubscribe();
    }

    onViewChanged($event: eDetailsView) {
        this.detailsView = $event;
    }
    handlePdf() {
        this.downloadFile(this.archiveDocument?.documentLongId || 'no_name');
    }

    private downloadFile(filename: string) {
        const link = document.createElement('a');
        link.href = this.archiveDocument?.documentDownloadUrl || '';
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}